import Vue from 'vue'
import { get } from 'lodash-es'
import GtmPlugin from './GtmPlugin'
import { DEFAULT_CONFIG } from './defaultConfig'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

let gtmPlugin

function install(app, options = { id: '' }) {
  // Merge options if initialized differently than from default config
  options = { ...DEFAULT_CONFIG, ...options }

  // Initialize GtmPlugin, which uses the already present datalayer
  // This gets set by a typoscript file with the businessunicorns/bu_gtm
  gtmPlugin = new GtmPlugin(options)
  // Make gtm Plugin accessible globally in vue context
  app.prototype.$gtm = app.gtm = gtmPlugin

  // Middleware for intercepting / tracking routing
  if (options.vueRouter) {
    void routingMiddleware(app, options.vueRouter, options.ignoredViews, options.trackOnNextTick)
  }
}

async function routingMiddleware(app, vueRouter, ignoredViews = [], trackOnNextTick) {
  // Flatten routes name
  ignoredViews = ignoredViews.map(view => view.toLowerCase())

  vueRouter.afterEach(to => {
    // Ignore Tracking of named Routes if any have been set
    if (typeof to.name !== 'string' || ignoredViews.indexOf(to.name.toLowerCase()) !== -1) {
      return
    }

    // Read meta of to, if gtm value set, use this, else use route (to) name
    const name = to.meta && typeof to.meta.gtm === 'string' && !!to.meta.gtm ? to.meta.gtm : to.name

    // get additional event data from to-meta
    const additionalData = to.meta?.additionalData ?? {}
    // Get Path, URL and Locale
    const path = to.fullPath
    const url = window?.location?.href
    const locale = gtmPlugin?.options?.locale
    const customerNumber = gtmPlugin?.options?.customerNumber
    const googleTitle =
      to.name !== 'default'
        ? to.name
        : get(vueRouter.app.$root.$store, [
            'state',
            STOREMODULES.APP,
            APP_CONSTANTS.APP_CONFIG,
            APP_CONSTANTS.PAGE_TITLE_ENGLISH,
          ])
    additionalData['content_group'] = googleTitle || 'RouteWithoutTitle: ' + url

    // Track immediately or on next tick
    if (trackOnNextTick) {
      Vue.nextTick(() => {
        gtmPlugin?.trackView(name, path, url, locale, customerNumber, additionalData)
      })
    } else {
      gtmPlugin?.trackView(name, path, url, locale, customerNumber, additionalData)
    }
  })
}

export function createGtm(options) {
  return { install: app => install(app, options) }
}

export function useGtm() {
  return gtmPlugin
}

// Define default export for custom vue plugin
const _default = {
  install,
}

export default _default
